import {
  DATA_HAS_ERRORED,
  DATA_IS_LOADING,
  DATA_FETCH_SUCCESS,
  UPDATING_DATA,
  UPDATING_FILTERDATA,
  UPDATING_EDITFORMDATA,
  DATA_RESET_SUCCESS,
  FILTERDATA_RESET_SUCCESS,
  EDITDATA_RESET_SUCCESS,
  PARENTDATA_RESET_SUCCESS,
  UPDATING_PARENTCTRLDATA,
  RESET_SIDEBAR,
  SET_SIDEBAR_FORMID,
  SET_SIDEBAR_FORMNAME,
  SET_MODEL_FORMID,
  SET_MODEL_FORMNAME,
  SET_PAGE_PARAMS,
  SET_UPLOAD_PARAMS,
  RESET_RELOAD,
  DELELTE_KEY,
  BOOKMARK_SET,
  RESET_MODELPOPUP,
  REALTIME_SYNC,
  RESET_FORM,
  NOTIFICATION_IMPORT,
  SET_GUID,
  SET_SPLITVIEW_FORMID
} from '../config/constants';

export function dataHasErrored(bool) {
  return {
    type: DATA_HAS_ERRORED,
    hasErrored: bool
  };
}
export function dataIsLoading(bool) {
  return {
    type: DATA_IS_LOADING,
    isLoading: bool
  };
}
export function dataFetchSuccess(data) {

  return {
    type: DATA_FETCH_SUCCESS,
    data
  };
}
export function resetFormData(data, storekey) {
  return {
    type: DATA_RESET_SUCCESS,
    [storekey]: data,
    storekey: storekey
  }
}
export function resetFilterData(data) {

  return {
    type: FILTERDATA_RESET_SUCCESS,
    filterdata: data
  }
}
export function resetEditFormData(data) {
  return {
    type: EDITDATA_RESET_SUCCESS,
    editformdata: data
  }
}
export function resetParentCtrdata(data) {

  return {
    type: PARENTDATA_RESET_SUCCESS,
    data: data
  }
}
export function deleteKey(storekey) {
  return {
    type: DELELTE_KEY,
    storekey: storekey
  }
}
export function resetForm() {
  return {
    type: RESET_FORM
  }
}
export function updateData(key, value, storekey) {
  return {
    type: UPDATING_DATA,
    key: key,
    value: value,
    storekey: storekey
  }
}
export function updateFilterData(key, value, key2 = '') {
  return {
    type: UPDATING_FILTERDATA,
    key: key,
    value: value,
    key2: key2
  }
}
export function updateEditData(key, value) {
  return {
    type: UPDATING_EDITFORMDATA,
    key: key,
    value: value
  }
}
export function updateParentCtrData(key, value) {
  return {
    type: UPDATING_PARENTCTRLDATA,
    key: key,
    value: value
  }
}
export function FetchData(url, filterdatajson) {
  return dispatch => {
    dispatch(dataFetchSuccess(url));
    dispatch(dataIsLoading(false));
  };
}
export function resetSidebar(isSidebarOpened) {
  return {
    type: RESET_SIDEBAR,
    isSidebarOpened: isSidebarOpened
  };
}
export function resetModelPopup(isModelOpened) {
  return {
    type: RESET_MODELPOPUP,
    isModelOpened: isModelOpened
  };
}
export function resetRealTimeSync(sync) {
  return {
    type: REALTIME_SYNC,
    realtimeSync: sync
  };
}
export function setSidebarFormId(sidebarFormId) {
  return {
    type: SET_SIDEBAR_FORMID,
    sidebarFormId: sidebarFormId
  };
}
export function setSidebarFormName(sidebarFormName) {
  return {
    type: SET_SIDEBAR_FORMNAME,
    sidebarFormName: sidebarFormName
  };
}
export function setSplitViewFormId(splitviewFormId) {
  return {
    type: SET_SPLITVIEW_FORMID,
    splitviewFormId: splitviewFormId
  };
}
export function setGUID(GUID){
  return {
    type: SET_GUID,
    GUID: GUID
  };
}
export function setModelFormId(modelFormId) {
  return {
    type: SET_MODEL_FORMID,
    modelFormId: modelFormId
  };
}
export function setModelFormName(modelFormName) {
  return {
    type: SET_MODEL_FORMNAME,
    modelFormName: modelFormName
  };
}
export function setPageParams(data) {
  return {
    type: SET_PAGE_PARAMS,
    pageparams: data
  };
}
export function setUploadFromSubmit(data) {
  return {
    type: SET_UPLOAD_PARAMS,
    uploadparams: data
  };
}
export function setreload(bool) {
  return {
    type: RESET_RELOAD,
    reload: bool
  };
}
export function setBookMark(bookmark) {
  return {
    type: BOOKMARK_SET,
    bookmark: bookmark
  }
}
export function setImportNotification(status) {
  return {
    type: NOTIFICATION_IMPORT,
    notification_import: status
  }
}